var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('img',{staticClass:"image",attrs:{"src":require("@/appointments/images/appointment-instructions-example.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }